import { InjectionToken } from '@angular/core';
import { ZenAuthConfig } from '../configs/zenauth.config';

export const ZEN_AUTH_CONFIG = new InjectionToken<ZenAuthConfig>('ZenAuthConfig');
